// Agent v2 `playbooks` (PHASE D) — how one playbook reads in « Validations ».
// Pure. Tags mirror worker/src/lib/learningText.ts SITUATION_TAGS.
import type { PlaybookItem } from '@/lib/api';

export const TAG_LABEL: Record<string, string> = {
  first_contact: 'Premier message',
  price_question: 'Question de prix',
  price_objection: 'Trouve ça cher',
  photos: 'Envoi des photos',
  order_details: 'Infos de commande',
  payment: 'Paiement / avance',
  delivery_question: 'Question de livraison',
  express: 'Urgence / Express',
  edit_request: 'Modification d’album',
  upsell: 'Duo / Trio / Relief',
  complaint_damaged: 'Plainte : abîmé',
  complaint_disliked: 'Plainte : pas aimé',
  complaint_delivery: 'Plainte : livraison',
  complaint_refund: 'Plainte : argent',
  complaint_angry: 'Client fâché',
  other: 'Autre',
};

export const PLAYBOOK_STATUS_LABEL: Record<PlaybookItem['status'], string> = {
  proposed: 'Proposé',
  approved: 'Validé',
  rejected: 'Refusé',
};

export const PLAYBOOK_STATUS_TONE: Record<PlaybookItem['status'], string> = {
  proposed: 'bg-amber-50 text-amber-800 border-amber-200',
  approved: 'bg-emerald-50 text-emerald-700 border-emerald-200',
  rejected: 'bg-gray-50 text-gray-600 border-gray-200',
};

export const tagLabel = (tag: string | null | undefined): string => TAG_LABEL[tag ?? 'other'] ?? TAG_LABEL.other;

/** « 3 conversations, dont 2 reprises par une personne ». */
export function casesLine(p: Pick<PlaybookItem, 'cases'>): string {
  const n = p.cases?.length ?? 0;
  if (!n) return '';
  const human = p.cases.filter((c) => c.human_took_over).length;
  return `${n} conversation${n > 1 ? 's' : ''} réussie${n > 1 ? 's' : ''}` + (human ? `, dont ${human} reprise${human > 1 ? 's' : ''} par une personne` : '');
}

/** « Utilisé 4 fois » / null. */
export function usesLine(p: Pick<PlaybookItem, 'uses_count' | 'status'>): string | null {
  const n = Number(p.uses_count) || 0;
  if (p.status !== 'approved') return null;
  return n ? `Utilisé ${n} fois` : 'Pas encore utilisé';
}

/** Split the list for the tab: what waits for him, what is live, the last refusals. */
export function splitPlaybooks(items: PlaybookItem[]): { proposed: PlaybookItem[]; approved: PlaybookItem[]; rejected: PlaybookItem[] } {
  return {
    proposed: items.filter((p) => p.status === 'proposed'),
    approved: items.filter((p) => p.status === 'approved'),
    rejected: items.filter((p) => p.status === 'rejected').slice(0, 10),
  };
}
